export const ticketGroupTableContants = {
  SET_SELECTED_ID: 'TICKET_GROUP_TABLE_SET_SELECTED_ID',
  CLEAR_SELECTED_ID: 'TICKET_GROUP_TABLE_CLEAR_SELECTED_ID',
  BULK_SET_SELECTED_ID: 'TICKET_GROUP_TABLE_BULK_SET_SELECTED_ID',
  SET_SELECTED_ALL: 'TICKET_GROUP_TABLE_SET_SELECTED_ALL',
  RESET_STATE: 'TICKET_GROUP_TABLE_RESET_STATE',
};

export declare type SELECTED_ALL_VALUES = 'ALL' | 'NONE' | 'SOME';
